import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { isIndividual } from '@rma/common-ui-domain/helpers';
import { INDIVIDUAL, type ProfileType } from '@rma/common-ui-domain/types';
import { BrokenImageDirective } from '@rma/generic/ui/broken-image';
import { TrixelComponent } from '@rma/generic/ui/trixels';
import { AvatarLandscape, AvatarLarge, AvatarStandard, RmaImageSize } from '@rma/generic/util/pipes/image-optimiser';

@Component({
  selector: 'rma-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  imports: [TrixelComponent, BrokenImageDirective, NgOptimizedImage],
  host: {
    class: 'block relative rounded-full overflow-hidden',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileAvatarComponent {
  private readonly agencyPlaceholderImage = 'placeholder/agency.jpg';
  private readonly agentPlaceholderImage = 'placeholder/agent.jpg';

  public readonly avatar = input<string>();
  public readonly name = input<string>();
  public readonly profileType = input<ProfileType | null | undefined>(INDIVIDUAL);
  public readonly trixelUrl = input<string>();
  public readonly lazyLoad = input(true);
  public readonly backgroundColour = input<string>();
  public readonly size = input<'standard' | 'landscape' | 'large'>('standard');

  public readonly transformations = computed<RmaImageSize>(() => {
    switch (this.size()) {
      case 'large':
        return AvatarLarge;
      case 'landscape':
        return AvatarLandscape;
      case 'standard':
      default:
        return AvatarStandard;
    }
  });

  public readonly placeholderImage = computed(() =>
    isIndividual(this.profileType()) ? this.agentPlaceholderImage : this.agencyPlaceholderImage,
  );
}
